import {
  Typography,
  Card,
  Box,
  Button,
  IconButton,
  CardContent,
} from "@material-ui/core"
import DeleteForeverIcon from "@material-ui/icons/DeleteForever"
import React, { useContext } from "react"
import useStyles from "./styles"
import AddIcon from "@material-ui/icons/Add"
import { useDispatch, useSelector } from "react-redux"
import { withRouter } from "react-router"
import SimpleExpenseTotal from "../../Common/SimpleExpenseTotal/index"
import PropTypes from "prop-types"
import RoleIdentityComponent from "../../Common/RoleIdentityComponent/index"
import ExpenseTable from "../../Common/ExpenseTable/index"
import { v4 as uuidv4 } from "uuid"
import {
  editableDealMemoColumns,
  mobileEditableDealMemoColumns,
} from "../../../../pages/Shoot/pages/Billing/BillingContext"
import {
  updateExpense,
  updateExpenseFlagStatus,
  deleteExpense,
  deleteShootRoleCall,
  addDealMemoItem,
  createExpense,
  reorderUsersRolesArray,
  updateItemsOrder,
} from "../../../../actions/billing"
import { toggleFlaggingDialog } from "../../../../actions/billingDialogs"
import { openSnackBar } from "../../../../actions/snack-bar"
import { toggleClickConfirmationDialog } from "../../../../actions/billingDialogs"
import isUuid from "../../../../utils/isUuid"
import BillingContext from "../../../../pages/Shoot/pages/Billing/BillingContext"
import ButtonsComponent from "./ButtonsComponent/index"
import ApprenticeAutocomplete from "../ApprenticeAucomplete/index"
import useBillingDisabled from "../../../../hooks/useBillingDisabled"
import useIsGTT from "../../../../hooks/useIsGTT"
import useFirstGTTMember from "../../../../hooks/userFirstGTTMember"
import useActiveCompanyAdesk from "../../../../hooks/useActiveCompanyAdesk"
import useHaveGTT from "../../../../hooks/useHaveGTT"
import CopyLinkButton from "../../Common/CopyLinkButton/index"
import DownloadPdfButton from "../../Common/DownloadPdfButton/index"

const DealMemoCard = ({ position = {}, shootId, ...props }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const billingContext = useContext(BillingContext)
  const usersRolesArray = useSelector(state => state.billing.usersRolesArray)
  const generalData = useSelector(state => state.billing.generalData)
  const isDisabled = useBillingDisabled()
  const isGTT = useIsGTT(position)
  const firstGTTMember = useFirstGTTMember(usersRolesArray)
  const currentUserIsAdesk = useActiveCompanyAdesk()

  const viewportWidth =
    window.innerWidth || document.documentElement.clientWidth

  // *** RESOLVE FLAG   ***
  const resolveCrewFlag = (nextStatusObj, expenseId) => {
    // args come from handleFlagDialog function, which accesses them from the expense table
    let crewFlagStatus = {
      crew_flag_status_id: nextStatusObj.crew_flag_status_id,
      crew_flag_comment: nextStatusObj.comment,
      shootRole: nextStatusObj.shootRole,
      type: "crew",
    }
    // crewFlagStatus marries the agnostic "comment" from nextStatus obj to the crew-specific flag comment key
    dispatch(updateExpenseFlagStatus(crewFlagStatus, expenseId))
      .then(() => {
        dispatch(openSnackBar({ message: "Flag removed successfully" }))
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error removing flag" }))
      })
  }

  const handleFlagDialog = (nextStatus, item) => {
    // statusCodeObj { status_id: #}, itemId is the expense_id of the chosen expense
    // args come from Expense Table handleFlag fn, not from within this file
    const data = {
      flagFunc: resolveCrewFlag,
      nextStatus: { ...nextStatus, shootRole: item.shoot_role },
      comment: item.crew_flag_comment,
      funcParams: [item.expense_id],
    }
    dispatch(toggleFlaggingDialog(true, data))
  }

  // *** RESOLVE FLAG END  ***

  // *** ADD BLANK ITEM   ***

  const addItem = () => {
    let newExpense = {
      expense_id: uuidv4(),
      shoot_id: Number(shootId),
      shootRoleId: position.id || position.shoot_role,
      user_id: position.user_id || null,
      type_name: "",
      item_type: null,
      quantity: 0,
      actual_rate: 0,
      client_rate: 0,
      discount: 0,
      description: "",
      is_percentage: 0,
      client_flag_status: "accepted",
      //in a new expense if is a go to team add his id to the class
      //if is not  a go to team add the first gtt member in the shoot
      //if not mark vendor (this should never happen)
      class:
        position.user_company === "Go To Team"
          ? position.user_id
          : firstGTTMember
            ? firstGTTMember
            : "vendor",
    }
    billingContext.setUnsavedState(oldState => [
      ...oldState,
      `e${newExpense.expense_id}`,
    ])
    dispatch(addDealMemoItem(newExpense))
  }

  // *** ADD BLANK END   ***

  // *** DELETE SHOOT ROLE  ***

  const deleteShootRole = (shootRoleId, userId) => {
    dispatch(deleteShootRoleCall(shootRoleId, shootId, userId))
      .then(() => {
        dispatch(openSnackBar({ message: "User/role deleted" }))
      })
      .catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error deleting user/role" }))
      })
  }
  const openConfirmDialog = () => {
    let data = {
      action: "delete this role",
      confirmationFunc: deleteShootRole,
      funcArgs: [position.shoot_role || position.id, position.user_id],
    }
    dispatch(toggleClickConfirmationDialog(true, data))
  }

  const handleDelete = (item, unsavedState) => {
    if (billingContext.unsavedState.includes(`e${item.expense_id}`)) {
      billingContext.setUnsavedState(oldState => {
        return [
          ...oldState
            .map(x => {
              if (x !== `e${item.expense_id}`) {
                return x
              }
            })
            .filter(x => x),
        ]
      })
    }
    dispatch(deleteExpense(item.expense_id, item.shoot_role))
  }

  const openDeleteConfirmation = (item, unsavedState) => {
    let data = {
      action: "delete this expense",
      confirmationFunc: handleDelete,
      funcArgs: [item, unsavedState],
    }
    dispatch(toggleClickConfirmationDialog(true, data))
  }
  // *** DELETE ITEM END ***

  const handleSave = (values, actions, item, deal_memo_order) => {
    if (billingContext.unsavedState.includes(`e${item.expense_id}`)) {
      billingContext.setUnsavedState(oldState => {
        return [
          ...oldState
            .map(x => {
              if (x !== `e${item.expense_id}`) {
                return x
              }
            })
            .filter(x => x),
        ]
      })
    }

    actions.setSubmitting(true)
    if (!isUuid(item.expense_id)) {
      let updateExpenseData = {
        expense_id: item.expense_id,
        type_name: values.type_name,
        item_type: values.item_type,
        quantity: values.quantity,
        actual_rate: values.actual_rate,
        client_rate: values.client_rate,
        discount: values.discount,
        is_percentage: item.is_percentage,
        description: values.description,
        class: values.class,
        deal_memo_order: deal_memo_order,
      }
      //update the server and redux
      dispatch(updateExpense(updateExpenseData, item.expense_id))
        .then(() => {
          dispatch(openSnackBar({ message: "Item updated" }))
          actions.setSubmitting(false)
          actions.resetForm({ values: values })
        })
        .catch(err => {
          console.log(err)
          dispatch(openSnackBar({ message: "Error updating item" }))
          actions.setSubmitting(false)
          actions.resetForm({ values: values })
        })
    } else if (isUuid(item.expense_id)) {
      let createdItem = {
        data: [
          {
            expense_id: item.expense_id,
            shoot_id: Number(shootId),
            shoot_role: item.shootRoleId,
            user_id: position.user_id,
            type_name: values.type_name,
            item_type: values.item_type,
            quantity: values.quantity,
            actual_rate: values.actual_rate,
            client_rate: values.client_rate,
            discount: values.discount,
            is_percentage: values.is_percentage,
            description: values.description,
            class: values.class,
            deal_memo_order: deal_memo_order,
          },
        ],
      }
      // create the expense on the server and redux
      dispatch(createExpense(createdItem))
        .then(() => {
          dispatch(openSnackBar({ message: "Item created" }))
          actions.setSubmitting(false)
          actions.resetForm({ values: values })
        })
        .catch(err => {
          dispatch(openSnackBar({ message: "Error creating item" }))
          console.log(err)
          actions.setSubmitting(false)
          actions.resetForm({ values: values })
        })
    }
  }

  //reorder items
  const setItemsOrder = newItemsArray => {
    dispatch(
      reorderUsersRolesArray(newItemsArray, position.id || position.shoot_role)
    )

    let orderData = newItemsArray.map((item, index) => ({
      expenseId: item.expense_id ? item.expense_id : item.additional_expense_id,
      expenseType: item.expense_id ? "dmi" : "admi",
      order: index + 1,
    }))

    dispatch(updateItemsOrder(orderData))
  }

  const haveGTT = useHaveGTT(usersRolesArray)

  // console.log('position', position);

  return (
    <Card className={classes.cardContainer}>
      <CardContent>
        <Box className={classes.topContainer}>
          <Box
            className={classes.leftContainer}
            display="flex"
            alignItems="center"
          >
            <RoleIdentityComponent role={position} showAvatar />
            {/* IMPORTANT: Adesk organization has 2 different type of users, go to team or crewmama crew. 
            The first ones has a different funcitonality called classes pay.
            This first part is to know if the current gtt member is an apprentice*/}
            {currentUserIsAdesk &&
              isGTT && <ApprenticeAutocomplete position={position} />}
          </Box>
          <Box
            className={classes.rightContainer}
            display="flex"
            alignItems="flex-end"
            flexDirection="column"
          >
            <Box display="flex" justifyContent="flex-end" marginBottom="10px">
              {/* {type === "deal-memo-card" ? ("") : ("")} */}
              <DownloadPdfButton
                type="deal-memo"
                data={{
                  ...position,
                  shoot_name: generalData && generalData.name,
                  company_id: generalData && generalData.company_id,
                  crewmama_or_gtt: generalData && generalData.crewmama_or_gtt,
                  company_logo_image:
                    generalData && generalData.company_logo_image,
                  start_date: generalData && generalData.start_date,
                  end_date: generalData && generalData.end_date,
                }}
              />
              <Box marginRight="10px" />
              <CopyLinkButton
                docType="deal-memo"
                uniqueString={position.unique_string}
              />
            </Box>
            <ButtonsComponent position={position} />
          </Box>
          <Box
            className={classes.deleteContainer}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <IconButton
              onClick={openConfirmDialog}
              className={classes.deleteIcon}
              disabled={isDisabled}
            >
              <DeleteForeverIcon />
            </IconButton>
          </Box>
        </Box>

        <Box className={classes.bottomContainer}>
          <ExpenseTable
            columns={
              viewportWidth < 600
                ? mobileEditableDealMemoColumns
                : editableDealMemoColumns
            }
            data={position}
          >
            <ExpenseTable.Header />
            <ExpenseTable.ItemsGroup
              items={position}
              setItems={setItemsOrder}
              draggable={true}
            >
              <ExpenseTable.ItemBar onSave={handleSave} isDisabled={isDisabled}>
                {/* name input */}
                <ExpenseTable.NameItem
                  style={
                    viewportWidth > 600
                      ? {
                          gridColumn: "type_name-start / quantity-start",
                          gridRow: "1/2",
                        }
                      : {
                          gridRow: "1/1",
                          gridColumn: "1/ span 6",
                        }
                  }
                />
                {/* name input ends */}
                {/* quantity input  */}
                <Box>
                  {viewportWidth < 600 && (
                    <Typography className={classes.mobileLabels}>
                      Qty
                    </Typography>
                  )}
                  <ExpenseTable.NumberItem
                    valueForProperty="quantity"
                    style={
                      viewportWidth > 600
                        ? {
                            gridColumn: "quantity-start / actual_rate-start",
                            gridRow: "1/2",
                          }
                        : {
                            gridRow: "1/3",
                            gridColumn: "1/ span 6",
                          }
                    }
                  />
                </Box>
                {/* quantity input ends  */}
                {/* actual_rate input  */}
                <Box>
                  {viewportWidth < 600 && (
                    <Typography className={classes.mobileLabels}>
                      Rate($)
                    </Typography>
                  )}
                  <ExpenseTable.NumberItem valueForProperty="actual_rate" />
                </Box>
                {/* actual_rate input ends */}
                {/* total input  */}
                {viewportWidth > 600 ? (
                  <ExpenseTable.TotalItem>
                    {values =>
                      (values.actual_rate * values.quantity).toFixed(2)
                    }
                  </ExpenseTable.TotalItem>
                ) : (
                  <Box style={{ gridColumn: "4/4", gridRow: "3/3" }}>
                    <Typography className={classes.mobileLabels}>
                      Total($)
                    </Typography>
                    <ExpenseTable.TotalItem justifyContent="center">
                      {values =>
                        (values.actual_rate * values.quantity).toFixed(2)
                      }
                    </ExpenseTable.TotalItem>
                  </Box>
                )}
                {/* total input ends */}
                {/* description input  */}
                <ExpenseTable.Item
                  valueForProperty="description"
                  haveGTT={haveGTT}
                  style={
                    viewportWidth > 600
                      ? viewportWidth > 960
                        ? {
                            gridColumn: haveGTT
                              ? "type_name-start / select-start"
                              : "1/ span 2",
                            gridRow: "2/2",
                          }
                        : {
                            gridColumn: "type_name-start / actual_rate-start",
                            gridRow: "2/2",
                          }
                      : {
                          gridRow: "2/2",
                          gridColumn: "1/ span 6",
                        }
                  }
                />
                {/* description input ends */}
                {/* class input  */}

                {/* IMPORTANT: Adesk organization has 2 different type of users, go to team or crewmama crew. 
                The first ones has a different funcitonality called classes pay.
                This second part is to know the "commission" of the go to team*/}
                <ExpenseTable.ClassesAutocomplete
                  position={position}
                  style={
                    viewportWidth > 600
                      ? viewportWidth > 960
                        ? {
                            gridColumn: "select-start / quantity-start",
                            gridRow: "2/2",
                            display: "flex",
                            alignItems: "center",
                            padding: "5px",
                          }
                        : {
                            gridColumn: "type_name-start /  actual_rate-start",
                            gridRow: "3/3",
                            display: "flex",
                            alignItems: "center",
                            padding: "5px",
                          }
                      : {
                          gridRow: "5/5",
                          gridColumn: "1/ span 6",
                          padding: "5px",
                        }
                  }
                />
                {/* class input ends */}
                {/* flag input  */}
                <ExpenseTable.FlagButton
                  hideIfNotFlagged
                  crewView
                  onClick={handleFlagDialog}
                />
                {/* flag input ends */}
                {/* save/delete buttons  */}
                <ExpenseTable.ButtonGroup
                  style={
                    viewportWidth > 600
                      ? viewportWidth > 960
                        ? {
                            gridColumn: "quantity-start / total-end",
                            gridRow: "2/2",
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            padding: "0 5px",
                          }
                        : {
                            gridColumn: "quantity-start / total-end",
                            gridRow: "3/3",
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            padding: "0 5px",
                          }
                      : {
                          gridColumn: "1/span 6",
                          gridRow: "7/7",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          padding: "0 5px",
                          marginBottom: "10px",
                          marginTop: "10px",
                        }
                  }
                >
                  <ExpenseTable.DeleteButton onClick={openDeleteConfirmation} />
                  <ExpenseTable.SaveButton />
                </ExpenseTable.ButtonGroup>
                {/* save/delete buttons ends */}
              </ExpenseTable.ItemBar>
            </ExpenseTable.ItemsGroup>
          </ExpenseTable>
          <Box className={classes.buttonContainer}>
            <Button
              color="secondary"
              onClick={addItem}
              disabled={isDisabled}
              className={classes.addItemButton}
            >
              <AddIcon className={classes.addIcon} />
              Add Item
            </Button>
          </Box>
          <SimpleExpenseTotal data={[position]} />
        </Box>
      </CardContent>
    </Card>
  )
}

DealMemoCard.propTypes = {
  position: PropTypes.object,
  shootId: PropTypes.string,
}

export default withRouter(DealMemoCard)
